// extracted by mini-css-extract-plugin
module.exports = {"layout":"CataloghiTemplate_layout__46EGf","list":"CataloghiTemplate_list__6PvAR","ctaBox":"CataloghiTemplate_ctaBox__1JGnS","rotation":"CataloghiTemplate_rotation__SvjNv"};